import { useEffect, useState, useMemo } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../lib/firebase";

import { CONFIG } from "../config";
/** ---- Config ---- */

const IMAGES_BASE = CONFIG.IMAGES_BASE

const clean = (v) => (typeof v === "string" ? v.trim() : "");

export function useMetaData(pagePath = null, override = null) {
  const [global, setGlobal] = useState({});
  const [page, setPage] = useState({});

  // 🌍 Global site-wide meta (metaconfig)
  useEffect(() => {
    const off = onValue(ref(db, "metaconfig"), (snap) => {
      setGlobal(snap.val() || {});
    });
    return () => off();
  }, []);

  // 📄 Per-page meta (homepageconfig/meta, aboutusconfig/meta, etc.)
  useEffect(() => {
    if (!pagePath) return;
    const off = onValue(ref(db, pagePath), (snap) => {
      setPage(snap.val() || {});
    });
    return () => off();
  }, [pagePath]);

  // 🧩 Merge priority: override > page > global
  const meta = useMemo(() => {
    const g = global || {};
    const p = page || {};
    const o = override || {};

    const metaTitle =
      clean(o.metaTitle) ||
      clean(p.metaTitle) ||
      clean(g.metaTitle) ||
      clean(g.siteTitle) ||
      "Website";

    const metaDescription =
      clean(o.metaDescription) ||
      clean(p.metaDescription) ||
      clean(g.metaDescription) ||
      "";

    const metaKeywords =
      clean(o.metaKeywords) ||
      clean(p.metaKeywords) ||
      clean(g.metaKeywords) ||
      "";

    const ogImage =
      clean(o.ogImage) ||
      clean(p.ogImage) ||
      "";

    const iconUrl = g.icon
      ? `${IMAGES_BASE}/${encodeURIComponent(g.icon)}`
      : "%PUBLIC_URL%/favicon.ico";

    const siteTitle = clean(g.siteTitle) || "";

    return { metaTitle, metaDescription, metaKeywords, ogImage, iconUrl, siteTitle };
  }, [global, page, override]);

  return meta;
}
